
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal-storage-options",
      function () {
        return require("private-next-pages/personal-storage-options/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal-storage-options"])
      });
    }
  